import cookie from 'js-cookie';
export function uuid() {
    return ((Math.random() * 1e6) >> 0).toString(36);
}
export const formatMoney = (num) => {
    const re = /(\d)(\d{3},)/;
    if (/[^0-9.]/.test(num)) {
        return '';
    }
    let str = num.toString();
    str = str.replace(/^(\d*)$/, '$1.');
    str = (str + '00').replace(/(\d*\.\d\d)\d*/, '$1');
    str = str.replace('.', ',');
    while (re.test(str)) {
        str = str.replace(re, '$1,$2');
    }
    str = str.replace(/,(\d\d)$/, '.$1');
    str = str.replace(/^\./, '0.');
    return str;
};
export const openNewPage = (url) => {
    const __sid = `Authorization=${cookie.get('Authorization')}`;
    const seg = url.indexOf('?') == -1 ? '?' : '&';
    const fullUrl = `${url}${seg}${__sid}`;
    window.open(fullUrl, '_blank');
};
export const parseRequsetParams = (map, field) => {
    const params = {};
    Object.keys(map).forEach((key) => {
        const { value, type } = map[key];
        if (type === 'FIXED') {
            params[key] = value;
        }
        else if (type === 'FORM') {
            params[key] = field.getValue(value);
        }
    });
    return params;
};
export const parseResponseParams = (map, data) => {
    const params = {};
    Object.keys(map).forEach((key) => {
        const { value, type } = map[key];
        if (type === 'FIXED') {
            params[key] = value;
        }
        else if (type === 'FORM') {
            params[key] = data[key];
        }
    });
    return params;
};
